import PropTypes from "prop-types";
import React from "react";

export default class OperationPerformer extends React.Component {
    static propTypes = {
        operation: PropTypes.func.isRequired,
        Component: PropTypes.func.isRequired,
        mapOperationToProps: PropTypes.func,
        mapOperationStateToProps: PropTypes.func,
        proxiedProps: PropTypes.object
    };
    static defaultProps = {
        mapOperationToProps: operation => ({ operation }),
        mapOperationStateToProps: state => state,
        proxiedProps: {}
    };
    state = {
        performing: false,
        result: null,
        error: null
    };
    performOperation = async (...args) => {
        try {
            this.setState({ performing: true, result: null, error: null });
            const result = await this.props.operation(...args);
            this.setState({ performing: false, result: result, error: null });
        } catch (err) {
            this.setState({ performing: false, result: null, error: err });
        }
    };
    render() {
        return (
            <this.props.Component
                {...this.props.proxiedProps}
                {...this.props.mapOperationStateToProps(this.state)}
                {...this.props.mapOperationToProps(this.performOperation)}
            />
        );
    }
}

export const withOperation = options => Component => proxiedProps => (
    <OperationPerformer
        operation={options.operation}
        Component={Component}
        mapOperationToProps={options.mapOperationToProps}
        mapOperationStateToProps={options.mapOperationStateToProps}
        proxiedProps={proxiedProps}
    />
);



// WEBPACK FOOTER //
// ./src/components/OperationPerformer/index.js